var MedwaySchools = MedwaySchools || {};

(function (window, $, app) {
    var parseFloat = window.parseFloat;
    var vars = {};
    
    app.supports = function (feature) {
        return window.Modernizr[feature];
    };
    
    app.rejects = function (feature) {
        return ! window.Modernizr[feature];
    };
    
    app.exec = function (name) {
        app.ActionResolver.exec.apply(app.ActionResolver, arguments);
    };
    
    app.registerAction = function (name, action) {
        app.ActionResolver.registerAction(name, action);
    };
    
    app.bind = function () {
        app.$doc.ready(function () {
            var Modernizr = window.Modernizr;
            
            for (var prop in Modernizr) {
                if (Modernizr.hasOwnProperty(prop)) {
                    if (Modernizr[prop] === false) {
                        window.console.warn('Your browser does not support "' + prop + '", please consider upgrading to a modern browser like Google Chrome <https://www.google.com/chrome/>');
                    }
                }
            }
        });
        
        app.registerAction('go-to-sign-up', function () {
            if (! vars.$signUpForm) {
                vars.$signUpForm = $('#sign-up-form');
            }
            
            app.exec('Scroll.to', 'sign-up-btn');
            
            if (! vars.$signUpForm.is(':visible')) {
                app.exec('sign-up');
            }
        });
        
        app.registerAction('sign-up', function () {
            if (! vars.$signUpForm) {
                vars.$signUpForm = $('#sign-up-form');
            }
            
            var start = 0;
            var end = 0;
            var total = 0;
            var order = ['marginTop', 'paddingTop', 'height', 'paddingBottom', 'marginBottom'];
            var reversed = false;
            var animations = {};
            
            vars.$signUpForm.slideToggle({
                duration: app.ANIMATION_DURATION * 2,
                start: function (anim) {
                    var i;
                    
                    for (i in anim.tweens) {
                        if (! anim.tweens.hasOwnProperty(i)) {
                            continue;
                        }
                        
                        var tween = anim.tweens[i];
                        
                        if (tween.start <= 1) {
                            end += tween.end;
                            total += tween.end;
                            animations[tween.prop] = {
                                start: 0,
                                end: tween.end,
                                total: tween.end
                            };
                        } else {
                            if (! reversed) {
                                reversed = true;
                                
                                order.reverse();
                            }
                            
                            total += tween.start;
                            animations[tween.prop] = {
                                start: tween.start,
                                end: 0,
                                total: tween.start
                            };
                        }
                    }
                    
                    var pos = 0;
                    
                    for (i in order) {
                        if (! order.hasOwnProperty(i)) {
                            continue;
                        }
                        
                        var prop = order[i];
                        
                        if (animations[prop]) {
                            animations[prop].startPos = pos;
                            animations[prop].fraction = animations[prop].total / total;
                            pos += animations[prop].fraction;
                            animations[prop].endPos = pos;
                            animations[prop].completed = false;
                        } else {
                            animations[prop] = {
                                start: 0,
                                end: 0,
                                total: 0,
                                startPos: 0,
                                endPos: 0,
                                fraction: 0,
                                completed: true,
                            };
                        }
                    }
                },
                step: function (now, fx) {
                    var i;
                    var anim = animations[fx.prop];
                    var processed = 0;
                    var remaining = 0;
                    var css = {};
                    
                    if (fx.pos > anim.startPos && fx.pos < anim.endPos) {
                        var animOrder = order.indexOf(fx.prop);
                        
                        for (i = 0; i < order.length; i++) {
                            if (i == animOrder) {
                                continue;
                            }
                            
                            var prop = order[i];
                            
                            if (i < animOrder) {
                                processed += animations[prop].total;
                            } else {
                                remaining += animations[prop].total;
                            }
                        }
                        
                        fx.now = anim.start === 0 ? ((total * fx.pos) - processed) : ((total - (total * fx.pos)) - remaining);
                        
                        return fx.now;
                    }
                    
                    if (fx.pos < anim.startPos) {
                        fx.now = anim.start;
                        
                        return fx.now;
                    }
                    
                    if (fx.pos === 0) {
                        return fx.now;
                    }
                    
                    fx.now = anim.end;
                    
                    return fx.now;
                }
            });
        });
    };
})(window, jQuery, MedwaySchools);
